import React, { FC } from "react";
import { QuestionProps } from "../../../pages/form";
import { LocalDateInput } from "./components/local-date-input";
import { Maybe } from "graphql/jsutils/Maybe";
import { Core_LocalDateMsg } from "../../../src/generated/graphql";

export const LocalDateQuestion: FC<QuestionProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const localDateQuestion = question?.localDate;
  const localDateValue = answer?.value?.localDate?.value;

  function answerQuestion(value: Maybe<Core_LocalDateMsg> | undefined) {
    onAnswer({
      localDate: { value },
    });
  }

  return (
    <div>
      <LocalDateInput value={localDateValue} onChange={answerQuestion} />
    </div>
  );
};
